import { createFileRoute } from '@tanstack/react-router';
import Journeys from '@/pages/journeys';
import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import CollectionsIndexPage from '@/pages/workspaces/journeys/collections/index.page';
import { LazyPage } from './-route-layouts';

function CollectionsIndexRoute() {
  const isHydraCollections = useFeatureFlag(AccountFeatureFlag.CollectionsInHydra);

  // Flag off: the embedded Ember app serves /collections. Route ownership
  // (route-ownership.ts) is gated on this same flag, so ownership and the
  // rendered app flip together.
  if (!isHydraCollections) {
    return <Journeys />;
  }

  return (
    <LazyPage>
      <CollectionsIndexPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/collections/')({
  component: CollectionsIndexRoute,
});
